/* 
 * It hides if the user doesn't have action permission
 */

/* global customElements */
import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {BaseComponent} from '../basecomponent.js';

class ActionMenuItem extends BaseComponent {
	
	static get properties() {
		return {	
			disabled: {
				type: Boolean
			},
			eclass: {type: String},
			style: {type: String}
		};
	}
	
	constructor() {
		super();	
		
		this.menu = [];
		this.theme = '';
		this.disabled = false;
		this.eclass = '';
		this.style = '';
				
		var actionButton = this;
		actionButton.addEventListener('click', function (event) {
			if (actionButton.disabled) {
				event.stopImmediatePropagation();
				event.stopPropagation();
				event.preventDefault();							
			}
		});	
		
		setTimeout(function(){
			actionButton.init();
		});
	}
	
	render() {	
		return html`
			<style> 
				.action-button-container {				
					padding: 10px;
				}
		
				.action-button-container:hover {				
					background-color: aliceblue;
				}
		
				.disabled {
					background-color: #c4cad3;
					color: white;
				}
		
				.disabled:hover {
					background-color: #c4cad3;
				}
		
				.hide {
					display: none;
				}
		
			</style> 
			<div itemid='container' style='${this.style}' class='action-button-container ${this.eclass} ${this.disabled ? 'disabled' : ''}' ?disabled=${this.disabled}>
				<slot></slot>
			</div>
		`;
	}
	
	init() {
		var actionButtonFull = this;
	
		actionButtonFull.addEventListener('click', function (event) {
			if (actionButtonFull.disabled) {
				event.stopPropagation();
				event.preventDefault();
			}
		});
		
		var container = ElementUtil.query(actionButtonFull, 'container');

		container.classList.add('hide');
		Service.getUserService().getCurrentUser().then(function (user) {

			var valid = false;
			if (actionButtonFull.getAttribute('permissions')) {
				var permissions = actionButtonFull.getAttribute('permissions').split(',');
				var permissionOp = actionButtonFull.getAttribute('permission-op') || 'OR';


				if (permissions) {
					if (permissionOp === 'OR') {
						var haveCount = 0;
						permissions.forEach(function (permission) {
							if (user.hasPermission(permission)) {
								haveCount++;
							}
						});
						if (haveCount > 0) {
							valid = true;
						}
					} else {
						var haveCount = 0;
						permissions.forEach(function (permission) {
							if (user.hasPermission(permission)) {
								haveCount++;
							}
						});
						if (haveCount === permissions.length) {
							valid = true;
						}
					}
				} else {
					valid = true;
				}
			} else {
				valid = true;
			}


			if (valid) {
				container.classList.remove('hide');
			}

		});		
		
	}
	
};
customElements.define('dl-action-menu-item', ActionMenuItem);


